/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiAttendeeFeaturesFromJSON, StreemApiAttendeeFeaturesToJSON, StreemApiMeetingFeaturesAudioFromJSON, StreemApiMeetingFeaturesAudioToJSON, StreemApiMeetingFeaturesContentFromJSON, StreemApiMeetingFeaturesContentToJSON, StreemApiMeetingFeaturesVideoFromJSON, StreemApiMeetingFeaturesVideoToJSON, } from './';
export function StreemApiMeetingFeaturesFromJSON(json) {
    return StreemApiMeetingFeaturesFromJSONTyped(json, false);
}
export function StreemApiMeetingFeaturesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attendee': !exists(json, 'attendee') ? undefined : StreemApiAttendeeFeaturesFromJSON(json['attendee']),
        'audio': !exists(json, 'audio') ? undefined : StreemApiMeetingFeaturesAudioFromJSON(json['audio']),
        'content': !exists(json, 'content') ? undefined : StreemApiMeetingFeaturesContentFromJSON(json['content']),
        'video': !exists(json, 'video') ? undefined : StreemApiMeetingFeaturesVideoFromJSON(json['video']),
    };
}
export function StreemApiMeetingFeaturesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attendee': StreemApiAttendeeFeaturesToJSON(value.attendee),
        'audio': StreemApiMeetingFeaturesAudioToJSON(value.audio),
        'content': StreemApiMeetingFeaturesContentToJSON(value.content),
        'video': StreemApiMeetingFeaturesVideoToJSON(value.video),
    };
}
//# sourceMappingURL=StreemApiMeetingFeatures.js.map